import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ZoomOut2"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.24951 10.5C1.24951 5.39139 5.3909 1.25 10.4995 1.25C15.6081 1.25 19.7495 5.39139 19.7495 10.5C19.7495 12.7841 18.9216 14.8749 17.5495 16.4886L21.914 20.8531L20.8534 21.9138L16.4889 17.5493C14.8751 18.9218 12.784 19.75 10.4995 19.75C5.3909 19.75 1.24951 15.6086 1.24951 10.5ZM10.4995 2.75C6.21933 2.75 2.74951 6.21981 2.74951 10.5C2.74951 14.7802 6.21933 18.25 10.4995 18.25C14.7797 18.25 18.2495 14.7802 18.2495 10.5C18.2495 6.21981 14.7797 2.75 10.4995 2.75ZM6.75 9.74902H14.25V11.249H6.75V9.74902Z"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ZoomOut2.vue"]]);
